// extracted by mini-css-extract-plugin
module.exports = {"Textarea":"Textarea_Textarea__24cPQ"};